import $ from 'jquery';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';

import { useUpdateAll } from './useUpdateAll';
import { queueFetch } from '../helpers/queueFetch';
import { positionSelector } from '../store/reducers/positionSlice/positionSlice';
import { stageSelector } from '../store/reducers/stageSlice/stageSlice';

export const useChangeDateStages = (isChangeStatus) => {
    const allStages = useSelector(stageSelector.selectAll);
    const allPositions = useSelector(positionSelector.selectAll);
    const stagesEntities = useSelector(stageSelector.selectEntities);

    const { updateAll, getStageChildren } = useUpdateAll(allStages[0]);

    const moveStageNew = (moveDays, positionsEntities, stage) => {
        const { allPositions: stagePositions } = getStageChildren(positionsEntities, stage);

        const updatedPositionsEntities = { ...positionsEntities };
        const queue = [];

        stagePositions.forEach((position) => {
            const planned = {
                ...position.planned,
                start_date: moment(position.planned.start_date).add(moveDays, 'days').format(),
                end_date: moment(position.planned.end_date).add(moveDays, 'days').format(),
            };

            if (position.planned.start_date) {
                updatedPositionsEntities[position.guid] = { ...position, planned };

                queue.push({
                    data: {
                        data: {
                            guid: position.guid,
                            startDate: moment(planned.start_date).format('YYYY-MM-DD'),
                            endDate: moment(planned.end_date).format('YYYY-MM-DD'),
                        },
                        type: 'update',
                        action: 'picker_update_stage',
                    },
                    subEntityType: 'step',
                    subEntityId: stage.id,
                    t: Date.now(),
                });
            }
        });

        if (queue.length) queueFetch(queue);

        return updatedPositionsEntities;
    };

    const onChangeStartDate = (newDate) => {
        let resultUpdating = {};

        const sortedStages = allStages.sort(
            (stageA, stageB) =>
                moment(stagesEntities[stageA.id].planned.start_date).valueOf() -
                moment(stagesEntities[stageB.id].planned.start_date).valueOf()
        );

        const sortedPositions = allPositions
            .filter((position) => position.planned.start_date)
            .sort(
                (positionA, positionB) =>
                    moment(positionA.planned.start_date).valueOf() -
                    moment(positionB.planned.start_date).valueOf()
            );

        const sortedLaborPositions = sortedPositions.filter(
            (position) => position.type === 'labor'
        );

        if (!sortedLaborPositions.length) {
            const firstMhd = sortedPositions[0].planned.start_date;
            const isNeedMove = newDate !== firstMhd;
            const moveDays = moment(newDate).diff(moment(firstMhd), 'days');
            sortedStages.forEach((stage) => {
                if (isNeedMove) {
                    const moveResult = moveStageNew(moveDays, resultUpdating, stage);
                    resultUpdating = { ...resultUpdating, ...moveResult };
                }
            });
            updateAll(resultUpdating);
            return null;
        }

        const firstStageInitStartDate = sortedLaborPositions[0].planned.start_date;
        const isNeedMove = newDate !== firstStageInitStartDate;
        const moveDays = moment(newDate).diff(moment(firstStageInitStartDate), 'days');
        sortedStages.forEach((stage) => {
            if (isNeedMove) {
                const moveResult = moveStageNew(moveDays, resultUpdating, stage);
                resultUpdating = { ...resultUpdating, ...moveResult };
            }
        });
        if (!isChangeStatus) {
            updateAll(resultUpdating);
        } else {
            loader.show();
            $.ajax({
                url: routable.getRoute('updateEstimateStatus'),
                type: 'post',
                data: { status: 'in_exploitations' },
                success() {
                    window.location.reload();
                },
                done() {
                    loader.hide();
                },
            });
        }
    };

    return {
        onChangeStartDate,
    };
};
